import React from "react"
import PropTypes from "prop-types"

// Material UI
import { makeStyles } from "@material-ui/core/styles"
import {
  Box,
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from "@material-ui/core"

// Icons
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"

const useStyles = makeStyles(theme => ({
  accordionSummaryRoot: {
    flexDirection: "row-reverse",
    paddingLeft: theme.spacing(0)
  },
  accordionDetailsRoot: {
    paddingTop: theme.spacing(0)
  }
}))

const defaultFaqs = [
  {
    question:
      "Will I receive any certification after completing a course from Suraasa?",
    answer:
      "Yes. You are awarded a certificate of achievement upon completion of any course from Suraasa. These certificates can be accessed and downloaded from the Suraasa portal throughout your lifetime."
  },
  {
    question:
      "What modes of payment can I use to enroll in this certification?",
    answer:
      "Suraasa accepts major modes of payment such as Debit Cards, Credit Cards, American Express Cards, and Wire Transfer. You can contact Suraasa Care for offline payments."
  },
  {
    question: "Can I access the course contents more than once?",
    answer:
      "Yes. You can access the course contents via Suraasa Web Portal or Mobile Applications as many times as you want within 12 months of enrolling into the certification."
  },
  {
    question: "How long do I have access to Suraasa to complete the courses?",
    answer:
      "All courses have a valid license for 12 months. If you sign up for courses in promotional packages, the deadline to complete them all remains 12 months."
  },
  {
    question:
      "What happens if I do not complete the certification within 12 months?",
    answer:
      "If you do not complete the certification within 12 months, you can ask for renewal of access for upto 6 months at a fee of $20 per month for each renewed course."
  }
]

export default function FAQ({ faqs }) {
  const classes = useStyles()

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Typography gutterBottom variant="h4" className="text-bolder">
            Frequently Asked Questions (FAQ)
          </Typography>
        </Grid>

        <Grid item xs={12} container direction="column" spacing={2}>
          {faqs.map((obj, key) => {
            return (
              <Grid item key={key}>
                <Accordion elevation={0}>
                  <AccordionSummary
                    classes={{
                      root: classes.accordionSummaryRoot
                    }}
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Box ml={1}>
                      <Typography className="text-bold" variant="h6">
                        {obj.question}
                      </Typography>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails
                    classes={{
                      root: classes.accordionDetailsRoot
                    }}
                  >
                    <Box ml={2}>
                      {/* <Typography variant="body1" color="textSecondary">
                        {obj.answer}
                      </Typography> */}
                      {typeof obj.answer === "string" ? (
                        <Typography
                          // @ts-expect-error can't avoid this
                          dangerouslySetInnerHTML={{ __html: obj.answer }}
                          variant="body1"
                          color="textSecondary"
                        />
                      ) : (
                        obj.answer
                      )}
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </Grid>
            )
          })}
        </Grid>
      </Grid>
    </>
  )
}

FAQ.propTypes = {
  faqs: PropTypes.array
}

FAQ.defaultProps = {
  faqs: defaultFaqs
}
